import { set } from '@/utils/vuex.js'

export default {
  SET_FILTER: set('filter'),
  SET_USERS: set('users')
}
